import api from './api';
import {
  CreateUserRequestDTO,
  CreateUserResponseDTO,
  GetUserInfoDTO,
  ListUsersResponseDTO,
  UpdateConfigurationDTO,
  UpdateUserRequestDTO,
  UpdateUserResponseDTO,
} from './dto/user.dto';

export async function getUserInfo(): Promise<GetUserInfoDTO> {
  const { data } = await api.get<GetUserInfoDTO>('user/me');
  return data;
}

export async function updateUserConfiguration(configuration: UpdateConfigurationDTO) {
  await api.patch('user/me/configuration', configuration);
}

export async function listUsers(): Promise<ListUsersResponseDTO> {
  const { data } = await api.get<ListUsersResponseDTO>('user/list');
  return data;
}

export async function createUser(request: CreateUserRequestDTO): Promise<CreateUserResponseDTO> {
  const { data } = await api.post<CreateUserResponseDTO>('user', request);
  return data;
}

export async function updateUser(userId: string, updateRequest: UpdateUserRequestDTO) {
  const { data } = await api.patch<UpdateUserResponseDTO>(`user/${userId}`, updateRequest);
  return data;
}

export async function deleteUser(userId: string) {
  await api.delete(`user/${userId}`);
}
